import { authFetch } from '~/services/fetch';
import { LatLng } from 'leaflet';
import { IIncident } from '../interfaces/IIncidentPhone';

interface IRequestStatistic {
  readonly agencyId: number | null;
  readonly deviceId: number | null;
  readonly typeId: string | number | null;
  readonly subtypeId: string | number | null;
  readonly startDate: Date | null;
  readonly endDate: Date | null;
  readonly exludeClosed: boolean;
  readonly cityId: number | null;
  readonly userId: number | null;
  readonly entryStatusId: number | null;
  readonly location: string | null;
  readonly occurrenceId: string | null;
  readonly districtId: number | null;
  readonly phone: string | null;
  readonly onlyOccurrence: boolean;
  readonly entryOriginId: number | null;
  readonly requester: string | null;
}

export async function getEntryDashboardTodayService() {
  try {
    const response = await authFetch({
      url: '/entry/dashboard/today',
      method: 'GET',
    })

    return response.data;

  } catch (error) {
    throw error
  }
}

export async function getEntryTimeByCenter({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/entry-time-by-center',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getEntryTimeByStation({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/entry-time-by-station',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getEntryTimeByUser({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/entry-time-by-user',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getOpenEntryByCenter({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/open-entry-by-center',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getEntryByCenter({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/entry-by-center',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getOpenEntryByStation({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/open-entry-by-station',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getEntryByStation({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/entry-by-station',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getOpenEntryByUser({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/open-entry-by-user',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getEntryByUser({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/entry-by-user',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getEntryByTypeSubtype({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/entry-by-type-subtype',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getEntryByType({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/entry-by-type',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getEntryByStatus({
  agencyId,
  deviceId,
  typeId,
  subtypeId,
  startDate,
  endDate,
  exludeClosed,
  cityId,
  userId,
  entryStatusId,
  location,
  occurrenceId,
  districtId,
  phone,
  onlyOccurrence,
  entryOriginId,
  requester,
}: IRequestStatistic) {
  try {
    const response = await authFetch({
      url: '/statistics/entry-by-status',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        typeId: typeId,
        subtypeId: subtypeId,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: exludeClosed,
        cityId: cityId,
        userId: userId,
        entryStatusId: entryStatusId,
        location: location,
        occurrenceId: occurrenceId ? Number(occurrenceId) : null,
        districtId: districtId,
        phone: phone,
        onlyOccurrence: onlyOccurrence,
        entryOriginId: entryOriginId,
        name: requester,
      }
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export async function getMarkersEntryService() {
  try {
    const { data } = await authFetch({
      url: '/entry/get-my-entries',
      method: 'POST'
    });

    const result = {};

    data.filter((entry) => entry.latitude && entry.longitude)
      .map((entry, index) => {
        if (entry.latitude && entry.longitude) {
          result[entry.id] = {
            id: entry.id,
            markerId: `entry-${entry.id}`,
            code: entry.id,
            location: entry?.location,
            position: new LatLng(entry.latitude, entry.longitude),
            typeName: entry?.typename,
            subtypeName: entry?.subtypename,
            isCurrent: false,
            dispatchedAt: entry.dispatched_at,
            typeId: entry.type_id,
            subtypeId: entry.subtype_id
          }
        }
        return false
      })
      .filter((item) => item)

    return result
  } catch (error) {
    throw error
  }
}

export async function getManagentStationsEntryService() {
  try {
    const { data } = await authFetch({
      url: '/entry/contact-center/overview',
      method: 'GET'
    });

    return data

  } catch (error) {
    throw error
  }
}

export async function getEntryProcedures({ typeId, subtypeId = null }) {
  try {
    const response = await authFetch({

      url: '/procedure/config/get-procedure',
      method: 'POST',
      data: {
        type_id: typeId,
        subtype_id: subtypeId,
        related: 0
      }
    })

    return response.data;

  } catch (error) {

    throw error
  }
}

export async function getManagentStationsTagService() {
  try {
    const { data } = await authFetch({
      url: '/contact-center/tags',
      method: 'GET'
    });

    return data

  } catch (error) {
    throw error
  }
}

export async function saveStationsPositions(stations) {
  try {
    const { data } = await authFetch({
      url: '/station/management',
      method: 'POST',
      data: {
        stations: stations
      }
    });

    return data

  } catch (error) {
    throw error
  }
}

export async function saveStationsManagementTags(tags) {
  try {
    const { data } = await authFetch({
      url: '/contact-center/tag/management',
      method: 'POST',
      data: {
        tags: tags
      }
    });

    return data

  } catch (error) {
    throw error
  }
}

export async function deleteTag(tagId) {
  try {
    const { data } = await authFetch({
      url: `/contact-center/tag/${tagId}`,
      method: 'DELETE',
    });

    return data

  } catch (error) {
    throw error
  }
}

export async function verifyExternalKeyRegistrtation({ plate, externalKeyTracking }) {
  try {
    const { data } = await authFetch({
      url: '/external-key/has-registration',
      method: 'POST',
      data: {
        plate: plate,
        external_key_tracking: externalKeyTracking
      }
    })

    return data

  } catch (error) {
    throw error
  }

}

export async function requestEntryAssociatedVehicleAllFromEntry({ entryId }) {
  try {
    const { data } = await authFetch({
      url: '/entry/associated-vehicle/all-from-entry',
      method: 'POST',
      data: {
        entry_id: entryId
      }
    })
    return data

  } catch (error) {
    throw error
  }
}

export async function hasIncidentByPhoneAndEntryId({ phone, entryId }) {
  try {
    const { data } = await authFetch({
      url: '/incident/get-phone-info',
      method: 'POST',
      data: {
        phone: phone,
        entry_id: entryId
      }
    })
    
    return data
  } catch (error) {
    throw error
  }
}

export async function callBackPhoneService(phone: string) {
  try {
    const { data } = await authFetch({
      url: '/entry/call-back',
      method: 'POST',
      data: {
        phone
      }
    })
    
    return data
  } catch (error) {
    throw error
  }
}

export async function getSuggestedDispatchGroups({ typeId, subtypeId }) {
  try {
    const { data } = await authFetch({
      url: '/entry/suggested-agencies',
      method: 'POST',
      data: {
        type_id: typeId,
        subtype_id: subtypeId,
      },
    })

    return data
  } catch (error) {
    throw error
  }
}